// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__23ML4","icon":"SortAdornment_icon___v5NU","up":"SortAdornment_up__jTeAH","down":"SortAdornment_down__2_Cbs","active":"SortAdornment_active__TGP2S"};